class ProductGallery99 extends HTMLElement {
  connectedCallback() {
   const modalContentInfo = this.closest('.quick-add-modal__content-info');
    if (modalContentInfo) {
      modalContentInfo.classList.add('quick-add-modal__content-info--has-product-99');
    }

    this.toggleButton = this.querySelector('[data-gallery-toggle]');
    this.togglePreviews = Array.from(this.querySelectorAll('[data-toggle-preview]'));
    this.productStack = this.querySelector('[data-gallery-stack="product"]');
    this.lookbookStack = this.querySelector('[data-gallery-stack="lookbook"]');
    this.productThumbs = this.querySelector('[data-gallery-thumbs="product"]');
    this.lookbookThumbs = this.querySelector('[data-gallery-thumbs="lookbook"]');
    this.thumbButtons = Array.from(this.querySelectorAll('[data-thumb-target]'));

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => this.toggleSource());
    }

    this.thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = this.querySelector(`#${button.dataset.thumbTarget}`);
        if (!target) return;
        this.scrollToImage(target);
        this.setActiveThumb(button);
      });
    });

    this.observeActiveImage();
  }

  scrollToImage(target) {
    const modalScrollContainer = this.closest('.quick-add-modal__content');

    if (modalScrollContainer) {
      const spacing = 24;
      const targetTop =
        target.getBoundingClientRect().top -
        modalScrollContainer.getBoundingClientRect().top +
        modalScrollContainer.scrollTop -
        spacing;

      modalScrollContainer.scrollTo({ top: targetTop, behavior: 'smooth' });
      return;
    }

    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const headerOffset = headerGroup ? headerGroup.offsetHeight : 0;
    const spacing = 100;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset - spacing;

    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  observeActiveImage() {
    const activeStack = this.lookbookStack && !this.lookbookStack.hidden ? this.lookbookStack : this.productStack;
    const images = Array.from(activeStack.querySelectorAll('.product-99__image'));
    if (!images.length) return;

    if (this.observer) this.observer.disconnect();

    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;

        const activeButton = this.thumbButtons.find(
          (button) => button.dataset.thumbTarget === visible.target.id
        );
        if (activeButton) this.setActiveThumb(activeButton);
      },
      { root: null, threshold: [0.5, 0.75, 1] }
    );

    images.forEach((image) => this.observer.observe(image));
  }

  setActiveThumb(activeButton) {
    this.thumbButtons.forEach((button) => button.classList.remove('is-active'));
    activeButton.classList.add('is-active');
  }

  updateTogglePreview(showingLookbook) {
    this.togglePreviews.forEach((img) => {
      img.hidden = showingLookbook
        ? img.dataset.togglePreview !== 'product'
        : img.dataset.togglePreview !== 'lookbook';
    });
  }

  toggleSource() {
    if (!this.lookbookStack) return;
    const showingLookbook = !this.lookbookStack.hidden;

    if (showingLookbook) {
      this.lookbookStack.hidden = true;
      this.productStack.hidden = false;
      if (this.lookbookThumbs) this.lookbookThumbs.hidden = true;
      if (this.productThumbs) this.productThumbs.hidden = false;
    } else {
      this.productStack.hidden = true;
      this.lookbookStack.hidden = false;
      if (this.productThumbs) this.productThumbs.hidden = true;
      if (this.lookbookThumbs) this.lookbookThumbs.hidden = false;
    }

    this.updateTogglePreview(!showingLookbook);
    this.thumbButtons = Array.from(this.querySelectorAll('[data-thumb-target]'));
    this.observeActiveImage();
  }
}

customElements.define('product-gallery-99', ProductGallery99);

class ProductCarouselMobile99 extends HTMLElement {
  connectedCallback() {
    this.frame = this.querySelector('.product-99__carousel-frame');
    this.toggleButton = this.querySelector('[data-carousel-lookbook-toggle]');
    this.togglePreviews = Array.from(this.querySelectorAll('[data-toggle-preview]'));

    this.sources = {};
    this.querySelectorAll('[data-carousel-track]').forEach((track) => {
      const key = track.dataset.carouselTrack;
      const dotsWrapper = this.querySelector(`[data-carousel-thumbs="${key}"]`);
      const thumbButtons = dotsWrapper
        ? Array.from(dotsWrapper.querySelectorAll('[data-carousel-thumb]'))
        : [];

      this.sources[key] = {
        track,
        dotsWrapper,
        thumbButtons,
        slides: Array.from(track.querySelectorAll('.product-99__carousel-slide')),
      };

      thumbButtons.forEach((button) => {
        button.addEventListener('click', () => this.goToSlide(Number(button.dataset.carouselThumb)));
      });
    });

    this.activeSource = 'product';
    this.activeIndex = 0;

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => this.toggleSource());
    }

    if (this.frame) {
      this.frame.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.frame.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
      this.frame.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      this.frame.addEventListener('touchcancel', () => { this.isTrackingSwipe = false; }, { passive: true });
    }

    window.addEventListener('resize', () => {
      this.setPosition(false);
      this.syncHeight();
    });

    // Element is display:none on desktop, so clientWidth reads 0 until it
    // actually becomes visible on mobile — ResizeObserver catches that moment.
    this.resizeObserver = new ResizeObserver(() => this.syncHeight());
    this.resizeObserver.observe(this);

    this.preloadAndSyncHeight();
  }

  preloadAndSyncHeight() {
    const source = this.sources[this.activeSource];
    if (!source) return;

    source.slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img) return;
      if (img.complete && img.naturalWidth) {
        this.syncHeight();
      } else {
        img.addEventListener('load', () => this.syncHeight(), { once: true });
      }
    });
  }

  onTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.isTrackingSwipe = true;
  }

  onTouchMove(event) {
    if (!this.isTrackingSwipe) return;
    const dx = Math.abs(event.touches[0].clientX - this.touchStartX);
    const dy = Math.abs(event.touches[0].clientY - this.touchStartY);
    // Mostly-vertical gesture -> let the page scroll instead of swiping the carousel
    if (dy > dx) this.isTrackingSwipe = false;
  }

  onTouchEnd(event) {
    if (!this.isTrackingSwipe) return;
    this.isTrackingSwipe = false;

    const SWIPE_THRESHOLD = 40;
    const endX = event.changedTouches[0].clientX;
    const deltaX = endX - this.touchStartX;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

    if (deltaX < 0) {
      this.goToSlide(this.activeIndex + 1);
    } else {
      this.goToSlide(this.activeIndex - 1);
    }
  }

  toggleSource() {
    const nextSource = this.activeSource === 'product' ? 'lookbook' : 'product';
    if (!this.sources[nextSource]) return;

    const current = this.sources[this.activeSource];
    const next = this.sources[nextSource];

    current.track.hidden = true;
    if (current.dotsWrapper) current.dotsWrapper.hidden = true;

    next.track.hidden = false;
    if (next.dotsWrapper) next.dotsWrapper.hidden = false;

    // Preview thumbnail always shows the OTHER source — i.e. what tapping switches to
    this.togglePreviews.forEach((img) => {
      img.hidden = img.dataset.togglePreview === nextSource;
    });

    this.activeSource = nextSource;
    this.activeIndex = 0;
    this.setPosition(false);
    this.setActiveThumb();
    this.preloadAndSyncHeight();
  }

  goToSlide(index) {
    const source = this.sources[this.activeSource];
    if (!source || !source.slides.length) return;

    const total = source.slides.length;
    this.activeIndex = (index + total) % total;
    this.setPosition(true);
    this.setActiveThumb();
    this.syncHeight();
  }

  syncHeight() {
    if (!this.frame) return;

    const source = this.sources[this.activeSource];
    const activeSlide = source ? source.slides[this.activeIndex] : null;
    const img = activeSlide ? activeSlide.querySelector('img') : null;
    if (!img || !img.naturalWidth || !img.naturalHeight) return;

    const width = this.frame.clientWidth;
    if (!width) return;

    const ratio = img.naturalHeight / img.naturalWidth;
    this.frame.style.height = Math.round(width * ratio) + 'px';
  }

  setActiveThumb() {
    const source = this.sources[this.activeSource];
    if (!source) return;

    source.thumbButtons.forEach((button) => button.classList.remove('is-active'));
    const activeButton = source.thumbButtons[this.activeIndex];
    if (activeButton) activeButton.classList.add('is-active');
  }

  setPosition(animate) {
    const source = this.sources[this.activeSource];
    if (!source) return;

    const offset = -this.activeIndex * this.clientWidth;

    if (animate) {
      gsap.to(source.track, { x: offset, duration: 0.4, ease: 'power2.out' });
    } else {
      gsap.set(source.track, { x: offset });
    }
  }
}

customElements.define('product-carousel-mobile-99', ProductCarouselMobile99);

document.addEventListener('click', (event) => {
  const shareButton = event.target.closest('[data-share-button]');
  if (shareButton) {
    const url = shareButton.dataset.url;
    if (navigator.share) {
      navigator.share({ url }).catch(() => {});
    } else {
      navigator.clipboard.writeText(url);
    }
  }
});

document.addEventListener('change', (event) => {
  const swatchLabel = event.target.closest('.variant-picker-99__options--swatch');
  if (!swatchLabel) return;

  const checkedInput = swatchLabel.querySelector('input:checked');
  if (!checkedInput) return;

  const label = swatchLabel.closest('.variant-picker-99__group')?.querySelector('[data-selected-color-label]');
  if (!label) return;

  const associatedLabel = swatchLabel.querySelector(`label[for="${checkedInput.id}"]`);
  const optionValue = associatedLabel ? associatedLabel.dataset.optionValue : checkedInput.value;

  label.textContent = optionValue;
});

// Low-stock message: re-check inventory against threshold whenever a
// variant option is picked. Selected option values are read directly
// off the checked swatch/radio inputs and matched against each
// variant's own options in the JSON (data-stock-note-variants) —
// this avoids racing Dawn's async variant-change fetch.
document.addEventListener('change', (event) => {
  const group = event.target.closest('.variant-picker-99__group');
  if (!group) return;

  const form = event.target.form;
  if (!form) return;

  document.querySelectorAll('[data-stock-note-variants]').forEach((script) => {
    const sectionId = script.dataset.stockNoteVariants;
    const noteEl = document.getElementById(`StockNote-99-${sectionId}`);
    if (!noteEl) return;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    const groups = Array.from(document.querySelectorAll(`.variant-picker-99__group`)).filter(
      (g) => g.querySelector('input')?.form === form
    );
    
    const selectedValues = groups.map((g) => {
        const checkedInput = g.querySelector('input:checked');
        if (!checkedInput) return null;
        const associatedLabel = g.querySelector(`label[for="${checkedInput.id}"]`);
        return associatedLabel?.dataset.optionValue || checkedInput.value;
    });

    const matchedVariant = data.variants.find((v) =>
      v.options.every((optionValue, index) => optionValue === (selectedValues[index] ?? null))
    );
    if (!matchedVariant) return;

    const isLowStock = matchedVariant.tracked && matchedVariant.qty > 0 && matchedVariant.qty <= data.threshold;
    noteEl.hidden = !isLowStock;
  });
});

// Wishlist button proxy — forwards clicks to Growave's shadow-DOM button
// and mirrors its data-in-wishlist state back onto our visible icon.
// Guests are redirected to login before Growave's proxy is ever bound.
// Wishlist button proxy — forwards clicks to Growave's shadow-DOM button
// and mirrors its data-in-wishlist state back onto our visible icon.
// Guests are redirected to login before Growave's proxy is ever bound,
// unless a test bypass is active (?wishlist_test=1 or theme editor design mode).
function initWishlistToggles() {
  const toggles = document.querySelectorAll('[data-wishlist-toggle]');

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('wishlist_test') === '1') {
    sessionStorage.setItem('wishlistTest99', '1');
  }
  const bypassLoginGate = sessionStorage.getItem('wishlistTest99') === '1' || window.wishlistDesignMode99;

  toggles.forEach((favoriteBtn) => {
    if (favoriteBtn.dataset.wishlistBound) return;
    favoriteBtn.dataset.wishlistBound = 'true';

    favoriteBtn.addEventListener('click', (event) => {
      if (!window.customerLoggedIn99 && !bypassLoginGate) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = window.accountLoginUrl99 || '/account/login';
      }
    }, true);

    if (!window.customerLoggedIn99 && !bypassLoginGate) return;

    const container = favoriteBtn.closest('.product-99__info-sticky') || favoriteBtn.parentElement;
    const gwPlaceholder = container?.querySelector('.gw-wl-add-to-wishlist-placeholder');
    if (!gwPlaceholder) return;

    const interval = setInterval(() => {
      const gwButton = gwPlaceholder.shadowRoot?.querySelector('.gw-toggle-wishlist-product-card-button');
      if (!gwButton) return;
      clearInterval(interval);

      favoriteBtn.addEventListener('click', () => gwButton.click());

      const syncState = () => {
        const isWishlisted = gwButton.getAttribute('data-in-wishlist') === 'true';
        favoriteBtn.setAttribute('aria-pressed', String(isWishlisted));
        favoriteBtn.classList.toggle('is-wishlisted', isWishlisted);
        favoriteBtn.dispatchEvent(
          new CustomEvent('wishlist:toggle', {
            bubbles: true,
            detail: { productId: favoriteBtn.dataset.productId, added: isWishlisted },
          })
        );
      };
      syncState();

      const stateObserver = new MutationObserver(syncState);
      stateObserver.observe(gwButton, { attributes: true, attributeFilter: ['data-in-wishlist'] });
    }, 100);

    setTimeout(() => clearInterval(interval), 10000);
  });
}

document.addEventListener('DOMContentLoaded', initWishlistToggles);

class ProductRecommendations99 extends HTMLElement {
  connectedCallback() {
    this.initializeRecommendations();
  }

  initializeRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-99__related');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.outerHTML;
          this.classList.remove('visually-hidden');
        } else {
          this.remove();
        }
      })
      .catch(() => {
        this.remove();
      });
  }
}

customElements.define('product-recommendations-99', ProductRecommendations99);